export default __webpack_public_path__ + "static/media/Virtual2-mobi.55ef8188.webp";